//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
  IconColors,
} from '@hub/design-system-base'
import { default as ChevronLeftSmallSVG } from './assets/small/chevron-left.inline.svg'

interface ChevronLeftSmallIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
  ariaLabel?: string
  color?: IconColors
}

export const ChevronLeftSmallIcon: React.FC<
  React.PropsWithChildren<ChevronLeftSmallIconProps>
> = forwardRef<ChevronLeftSmallIconProps, typeof ChakraIcon>(
  ({ boxSize = 'size-icon-sm', sx, ariaLabel, color }, ref) => (
    <ChakraIcon
      ref={ref}
      boxSize={boxSize}
      aria-label={ariaLabel}
      as={ChevronLeftSmallSVG}
      sx={sx}
      color={color}
    />
  )
)
